import React, { useEffect, useCallback } from 'react';
import { Field, change } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import { renderInput } from '@app/src/common/Input';
import { FieldForm } from '@app/src/common/FieldForm';
import * as validate from '@app/src/utils/validations';
import {
  TicketWrapper,
  CentralHelp,
  LinkHelp,
  FieldWrapper
} from './styled';
import { maxLength } from '@app/src/utils/normalize';
import {
  fetchDni,
  setDisabledDniInputs,
  clearDniData,
  fetchDniSuccess
} from '@app/src/views/StepPayment/formPayment';

interface Props {
  color: string;
}

export const TicketProfile: React.FC<Props> = ({ color }) => {
  const dispatch = useDispatch();
  const currentDni = useSelector(state => state.form.stepPayment.values.dni);
  const currentName = useSelector(state => state.form.stepPayment.values.name);
  const currentFatherLastName = useSelector(state => state.form.stepPayment.values.fatherLastName);
  const currentMotherLastName = useSelector(state => state.form.stepPayment.values.motherLastName);
  const isLoading = useSelector(state => state.dni.isFetching);
  const dniData = useSelector(state => state.dni.data);
  const isDisabledInputs = useSelector(state => state.dni.isDisabledInputs);
  const currentPhone = useSelector(state => state.form.stepPayment.values.phone);

  useEffect(() => {
    dispatch(change('stepPayment', 'name', ''));
    dispatch(change('stepPayment', 'fatherLastName', ''));
    dispatch(change('stepPayment', 'motherLastName', ''));
    dispatch(change('stepPayment', 'phone', ''));
    dispatch(setDisabledDniInputs(false));
    dispatch(clearDniData());
  }, [currentDni]);

  useEffect(() => {
    if (Object.keys(dniData).length > 0 && currentDni === dniData.documentNumber) {
      dispatch(change('stepPayment', 'name', dniData.name));
      dispatch(change('stepPayment', 'fatherLastName', dniData.fatherLastName));
      dispatch(change('stepPayment', 'motherLastName', dniData.motherLastName));
      dispatch(change('stepPayment', 'phone', dniData.phone));
      dispatch(setDisabledDniInputs(true));
      dispatch(fetchDniSuccess(dniData));
    }
  }, [dniData, currentDni]);

  const handleChangeDni = useCallback((value) => {
    if (value && value.length === 8) {
      dispatch(fetchDni(value));
    }
  }, [dispatch]);

  return(
  <React.Fragment>
    <TicketWrapper>
      <FieldForm label="N° de DNI">
        <Field
          name="dni"
          type="number"
          placeholder="Ingrese DNI"
          loading={isLoading}
          disabled={isLoading}
          component={renderInput}
          normalize={maxLength(8)}
          handleChange={handleChangeDni}
          validate={[validate.required, validate.dni]}
          defaultValue={currentDni}
        />
      </FieldForm>
      <FieldForm label="Nombres">
        <Field
          name="name"
          placeholder="Ingrese nombres"
          component={renderInput}
          maxLength={40}
          validate={[validate.required, validate.minLength2, validate.onlyLetters]}
          disabled={isDisabledInputs || isLoading}
          defaultValue={currentName}
        />
      </FieldForm>
      <FieldForm label="Apellido paterno">
        <Field
          name="fatherLastName"
          placeholder="Ingrese apellido"
          component={renderInput}
          maxLength={40}
          validate={[validate.required, validate.minLength2, validate.onlyLetters]}
          disabled={isDisabledInputs || isLoading}
          defaultValue={currentFatherLastName}
        />
      </FieldForm>
      <FieldForm label="Apellido materno">
        <Field
          name="motherLastName"
          placeholder="Ingrese apellido"
          component={renderInput}
          maxLength={40}
          validate={[validate.required, validate.minLength2, validate.onlyLetters]}
          disabled={isDisabledInputs || isLoading}
          defaultValue={currentMotherLastName}
        />
      </FieldForm>
    </TicketWrapper>
    <CentralHelp>Para cualquier consulta o modificación acerca de los datos de facturación contactarse con la <LinkHelp color={color} target="_blank" href="https://centraldeayuda.clasificados.pe/hc/es/requests/new">Central de ayuda</LinkHelp>.</CentralHelp>
    <FieldWrapper>
      <FieldForm label="Teléfono">
        <Field
          name="phone"
          type="number"
          component={renderInput}
          normalize={maxLength(11)}
          validate={[validate.required, validate.minLength6]}
          placeholder="Ingrese teléfono"
          defaultValue={currentPhone}
          disabled={isLoading}
        />
      </FieldForm>
    </FieldWrapper>
  </React.Fragment>
)};
